/**
 * Módulo de categorías — CRUD completo con lista para selects
 */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea el módulo de categorías
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo categorías
 */
export function createCategoriasModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/categorias',
        entityName: 'categoria',
        methods: { lista: true }
      },
      { authenticatedRequest }
    )
  };
}
